"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UTMParams = void 0;
exports.UTMParams = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
];
//# sourceMappingURL=utm.js.map